import { IExercise } from '../models/exercise';
import { disciplinesWithKnowledge } from './discipline';

export const getFilteredExercisesByKnowledgeFields = (
  questions: IExercise[]
) => {
  return questions.sort((a, b) => {
    const areaA =
      disciplinesWithKnowledge[a.area] ||
      disciplinesWithKnowledge[a.ancestors?.area?.slug] ||
      '';
    const areaB =
      disciplinesWithKnowledge[b.area] ||
      disciplinesWithKnowledge[b.ancestors?.area?.slug] ||
      '';

    return areaA.localeCompare(areaB);
  });
};

export const getExercisesAreas = (answers: IExercise[]) => {
  return answers
    .map((answer) => answer.area || answer?.ancestors?.area?.slug || '')
    .filter((value, index, self) => self.indexOf(value) === index);
};

export const getFilteredExercisesByArea = (answers: IExercise[]) => {
  return answers.sort((a, b) => {
    const areaA = a.area || a.ancestors?.area?.slug || '';
    const areaB = b.area || b.ancestors?.area?.slug || '';

    return areaA.localeCompare(areaB);
  });
};
export const getFilteredExercisesByOrder = (answers: IExercise[]) => {
  return answers.sort((a, b) => {
    const orderA = a.order as number;
    const orderB = b.order as number;
    return orderA - orderB;
  });
};
